export const graphOptions = {
  responsive: true,
  scaleBeginAtZero: true,
  maintainAspectRatio: true,
  tooltipYPadding: 10,
  tooltipXPadding: 10,
  bezierCurve: false,
  pointDot: false,
  datasetStrokeWidth: 1,
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false
        },
        ticks: {
          fontColor: '#b1bfc5',
          maxRotation: 0
        }
      }
    ],
    yAxes: [
      {
        gridLines: {
          drawBorder: false
        }
      }
    ]
  }
}
